import Backend from 'backend';
import {inject} from 'aurelia-framework';
import {Router} from 'aurelia-router';
import {FeatureCustomizationProvider} from "../util/feature-customization-provider";

@inject(Backend, Router, FeatureCustomizationProvider)
export class BreweryEditScreen {
    backend;

    // To be posted
    editbrewery;

    router;
    featureCustomizationProvider;

    constructor(backend, router, featureCustomizationProvider) {
        this.backend = backend;
        this.router = router;
        this.featureCustomizationProvider = featureCustomizationProvider;
    }

    activate(params) {
        return Promise.all([
            this.backend.BreweryCrud_getForEdit()
                .then(result => this.editbrewery = result.breweryEditDto),
          ])
    }

    submit() {
        return this.backend.BreweryCrud_edit(this.editbrewery)
            .then(() => this.router.navigateToRoute("brewery-details"))
    }
}
